// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_wNA","cls2":"MultiPaperNewsStory-cls2_BuJ MultiPaperNewsStory-cls1_wNA"};